import React from 'react'
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { useLocation, useNavigate } from 'react-router';

const SideBarList = ()=>{
    const navigate = useNavigate()
    const location = useLocation()
    return (
        <>     
        <p className="py-4 text-center fs-4 border-bottom card-border">
            Admin Panel
        </p>     
            <List>
                <ListItem disablePadding>
                    <ListItemButton className={location.pathname == '/panel' ? 'bg-footer text-dark fw-bold' : ''} onClick={()=>navigate('/panel')} >
                        <ListItemIcon>
                        </ListItemIcon>
                        <ListItemText>
                            <p className='my-0 font-poppins'>
                                <i className='fa fa-arrow-up text-dark'></i> Recruitment
                            </p>
                        </ListItemText>
                    </ListItemButton>
                </ListItem>
            </List> 
            <List>
                <ListItem disablePadding>
                    <ListItemButton className={location.pathname == '/panel/messages' ? 'bg-footer text-dark fw-bold' : ''} onClick={()=>navigate('/panel/messages')} >
                        <ListItemIcon>
                        </ListItemIcon>
                        <ListItemText>
                            <p className='my-0 font-poppins'>
                                <i className='fa fa-arrow-up text-dark'></i> Messages
                            </p>
                        </ListItemText>
                    </ListItemButton>
                </ListItem>
            </List>                                                               
            <List>
                <ListItem disablePadding>
                    <ListItemButton className={location.pathname == '/panel/newsletter' ? 'bg-footer text-dark fw-bold' : ''} onClick={()=>navigate('/panel/newsletter')} >
                        <ListItemIcon>
                        </ListItemIcon>
                        <ListItemText>
                            <p className='my-0 font-poppins'>
                                <i className='fa fa-pencil'></i> Newsletter
                            </p>
                        </ListItemText>
                    </ListItemButton>
                </ListItem>
            </List>
            <List>
                <ListItem disablePadding>
                    <ListItemButton className={location.pathname == '/panel/events' ? 'bg-footer text-dark fw-bold' : ''} onClick={()=>navigate('/panel/events')} >
                        <ListItemIcon>
                        </ListItemIcon>
                        <ListItemText>
                            <p className='my-0 font-poppins'>
                                <i className='fa fa-download'></i> Events
                            </p>
                        </ListItemText>
                    </ListItemButton>
                </ListItem>
            </List>
            <List>
                <ListItem disablePadding>
                    <ListItemButton className={location.pathname == '/panel/publications' ? 'bg-footer text-dark fw-bold' : ''} onClick={()=>navigate('/panel/publications')} >
                        <ListItemIcon>
                        </ListItemIcon>
                        <ListItemText>
                            <p className='my-0 font-poppins'>
                               <i className='fa fa-heart-o'></i> Publications
                            </p>
                        </ListItemText>
                    </ListItemButton>
                </ListItem>
            </List>            
            <List>
                <ListItem disablePadding>
                    <ListItemButton className={location.pathname == '/panel/executive' ? 'bg-footer text-dark fw-bold' : ''} onClick={()=>navigate('/panel/executive')} >
                        <ListItemIcon>
                        </ListItemIcon>
                        <ListItemText>
                            <p className='my-0 font-poppins'>
                                <i className='fa fa-pencil'></i> Executives
                            </p>
                        </ListItemText>
                    </ListItemButton>
                </ListItem>
            </List>
            <List>
                <ListItem disablePadding>
                    <ListItemButton className={location.pathname == '/panel/testimonies' ? 'bg-footer text-dark fw-bold' : ''} onClick={()=>navigate('/panel/testimonies')} >
                        <ListItemIcon>
                        </ListItemIcon>
                        <ListItemText>
                            <p className='my-0 font-poppins'>
                                <i className='fa fa-pencil'></i> Testimonies
                            </p>
                        </ListItemText>
                    </ListItemButton>
                </ListItem>
            </List>
        </>
    )
}

export default SideBarList